class Search {
	// 1. Describe and create/initiate our object
	constructor() {
		this.addSearchHTML()
		this.resultsDiv = document.getElementById('search-overlay__results')
		this.openButtons = document.querySelectorAll('.js-search-trigger')
		this.closeButton = document.querySelector('.search-overlay__close')
		this.searchOverlay = document.querySelector('.search-overlay')
		this.searchField = document.getElementById('search-term')
		this.isOverlayOpen = false
		this.isSpinnerVisible = false
		this.previousValue = ''
		this.typingTimer = null
		this.rootUrl = window.location.origin
		this.events()
	}

	// 2. Events
	events() {
		this.openButtons.forEach(button => button.addEventListener('click', () => this.openOverlay()))
		this.closeButton.addEventListener('click', () => this.closeOverlay())
		document.addEventListener('keydown', e => this.keyPressDispatcher(e))
		this.searchField.addEventListener('keyup', () => this.typingLogic())
	}

	// 3. Methods (function, action, etc.)
	typingLogic() {
		if (this.searchField.value !== this.previousValue) {
			clearTimeout(this.typingTimer)

			if (this.searchField.value) {
				if (!this.isSpinnerVisible) {
					this.resultsDiv.innerHTML = `<div class="spinner-loader mx-auto bg-white dark:bg-purpleOnyx py-40 rounded-md flex items-center justify-center"> <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-pearlyPurple " viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg></div>`
					this.isSpinnerVisible = true
				}
				this.typingTimer = setTimeout(() => this.getResults(), 750)
			} else {
				this.resultsDiv.innerHTML = ''
				this.isSpinnerVisible = false
			}
		}

		this.previousValue = this.searchField.value
	}

	getResults() {
		const searchTerm = this.searchField.value

		// Perform two fetch requests for posts and pages
		const postsFetch = fetch(`${this.rootUrl}/wp-json/wp/v2/posts?search=${searchTerm}`).then(res => res.json())
		const pagesFetch = fetch(`${this.rootUrl}/wp-json/wp/v2/pages?search=${searchTerm}`).then(res => res.json())

		Promise.all([postsFetch, pagesFetch])
			.then(([posts, pages]) => {
				const combinedResults = [...posts, ...pages]
				this.resultsDiv.innerHTML = `
          <h3 class="search-overlay__section-title text-xl px-7 py-5 dark:bg-purpleOnyx">Wyniki wyszukiwania</h3>
          ${
						combinedResults.length
							? '<ul class="link-list min-list px-7 py-5 grid gap-2 dark:bg-purpleOnyx ">'
							: '<p class="p-7">Nie znaleziono pasujących wyników </p>'
					}
            ${combinedResults
							.map(item => `<li class="link-underline w-fit"><a href="${item.link}">${item.title.rendered}</a></li>`)
							.join('')}
          ${combinedResults.length ? '</ul>' : ''}
        `
				this.isSpinnerVisible = false
			})
			.catch(() => {
				this.resultsDiv.innerHTML = '<p class="p-7">Wystąpił błąd. Spróbuj ponownie. </p>'
			})
	}

	keyPressDispatcher(e) {
		const activeElement = document.activeElement
		if (
			e.key === 's' &&
			!this.isOverlayOpen &&
			activeElement.tagName !== 'INPUT' &&
			activeElement.tagName !== 'TEXTAREA'
		) {
			this.openOverlay()
		}

		if (e.key === 'Escape' && this.isOverlayOpen) {
			this.closeOverlay()
		}
	}

	openOverlay() {
		this.searchOverlay.classList.remove('hidden')
		this.searchField.value = ''
		setTimeout(() => this.searchField.focus(), 301)
		this.isOverlayOpen = true
	}

	closeOverlay() {
		this.searchOverlay.classList.add('hidden')
		this.isOverlayOpen = false
	}

	addSearchHTML() {
		const searchHTML = `
			<div class=" fixed top-0 bottom-0 left-0 right-0  z-50 bg-overlay px-5 search-overlay hidden  flex-col " >

				<svg xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" width="40" height="40" class="fill-lightGray dark:fill-purpleOnyx absolute right-5 top-5 cursor-pointer search-overlay__close" aria-hidden="true" 
				><path d="M14.121,12,18,8.117A1.5,1.5,0,0,0,15.883,6L12,9.879,8.11,5.988A1.5,1.5,0,1,0,5.988,8.11L9.879,12,6,15.882A1.5,1.5,0,1,0,8.118,18L12,14.121,15.878,18A1.5,1.5,0,0,0,18,15.878Z"/></svg>

				<div class="flex justify-center mt-20 mb-5">


					<div class="relative md:text-xs sm:text-lg  w-full md:max-w-md md:justify-self-end ">
						<input type="search" placeholder="Czego szukasz ?" class=" px-7 py-5 border-2 rounded-md border-solid border-pearlyPurple dark:bg-purpleOnyx  w-full" id="search-term">

					</div>

				</div>
				<div class="main-wrapper mx-auto w-full  overflow-y-scroll  ">
					<div id="search-overlay__results" class=" bg-white dark:bg-purpleOnyx  rounded-md "></div>
				</div>
			</div>

	
		


    `
		document.body.insertAdjacentHTML('beforeend', searchHTML)
	}
}

const search = new Search()

export default Search
